import { parse } from 'url';

export type IsDomainRedirect = () => boolean;
export const isDomainRedirect: IsDomainRedirect = () => {
  const { query } = parse(window.location.href, true);

  return query && query['domainRedirect'] === 'true';
};
